import React from 'react';
import Page from '../page';
import Loader from '../loader/loader';
import { useGetDGSearchOptionsQuery } from '../../store/slices/apiSlice/data-grid-api-slice';
import DataGrid from './datagrid';

function DataGridPage() {
    const { isLoading } = useGetDGSearchOptionsQuery();

    return (
        <Page>
            <div className="px-0 px-md-4 py-1">
                {isLoading ? <Loader /> : <DataGrid />}
            </div>
        </Page>
    );
}

export default DataGridPage;
